import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _extends from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @format */

import React, { Component } from 'react';
import moment from 'moment';
import MediaQuery from 'react-responsive';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { Icon } from "../../_global";
import { responsiveQuery } from "../../../constants/css";
import { clearClickUrl, clickToShop } from "../../../reducers/shop";
import { openLoginModal } from "../../../reducers/user";
import { useDecision } from '@optimizely/react-sdk';
import { MerchantCoupon, CouponExpiry, DealCta, FlexWrapper, DateWrapper, CouponBody, TitleWrapper, CouponTitle, CouponWrapper, CouponCode, DesktopExpander, Expander, ExpanderPad, ImportantButton, InfoWrapper, CardInfo } from "./style";
import { OPTIMIZELY_FLAGS } from "../../../lib/optimizelyClient";
var CouponWithOptimizely = function CouponWithOptimizely(props) {
  var _useDecision = useDecision(OPTIMIZELY_FLAGS.INCENTIVE_NETWORK_OUTAGE),
    _useDecision2 = _slicedToArray(_useDecision, 1),
    isIncentiveNetworksDown = _useDecision2[0].enabled;
  return __jsx(Coupon, _extends({}, props, {
    isIncentiveNetworksDown: isIncentiveNetworksDown
  }));
};
var Coupon = /*#__PURE__*/function (_Component) {
  function Coupon() {
    var _this;
    _classCallCheck(this, Coupon);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, Coupon, [].concat(args)), _this.state = {
      infoIsExpanded: false
    }, _this.toggleInfo = function () {
      _this.setState(function (prevState) {
        return {
          infoIsExpanded: !prevState.infoIsExpanded
        };
      });
    }, _this.copyToClipboard = function (e) {
      var couponCode = e.target.innerText;
      if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        e.target.previousSibling.style.display = 'block';
        return window.clipboardData.setData('Text', couponCode);
      }
      if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
        var textarea = document.createElement('textarea');
        textarea.style.fontSize = '12pt';
        textarea.textContent = couponCode;
        textarea.style.position = 'fixed';
        document.body.appendChild(textarea);
        textarea.select();
        e.target.previousSibling.style.display = 'block';
        try {
          return document.execCommand('copy');
        } catch (ex) {
          console.warn('Copy to clipboard failed.', ex);
          return false;
        } finally {
          document.body.removeChild(textarea);
        }
      }
      return null;
    }, _this.doShop = function (merchant, coupon) {
      var user = _this.props.user;
      if (user.authenticated || user.authorized) {
        coupon ? window.open("/shop?id=".concat(merchant.replace(/\+/g, '%2B'), "&coupon=").concat(coupon)) : window.open("/shop?id=".concat(merchant.replace(/\+/g, '%2B')));
      } else {
        _this.props.openLoginModal(window.location.href);
      }
    }, _this.renderExpander = function (needsExpander) {
      if (_this.state.infoIsExpanded) {
        return __jsx(Expander, {
          onClick: _this.toggleInfo
        }, __jsx("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "20",
          height: "20",
          viewBox: "0 0 20 20"
        }, __jsx("path", {
          fill: "#323232",
          fillRule: "nonzero",
          d: "M20 10c0-5.524-4.476-10-10-10S0 4.476 0 10s4.476 10 10 10 10-4.476 10-10zM6.443 12.6c-.329.392-.868.392-1.197 0A1.101 1.101 0 0 1 5 11.89c0-.257.083-.518.25-.717l4.137-4.91c.333-.36.846-.35 1.167.031l4.198 4.984c.329.392.333 1.03 0 1.426-.33.392-.865.397-1.198 0L9.996 8.426 6.443 12.6z"
        })));
      }
      return needsExpander ? __jsx(Expander, {
        onClick: _this.toggleInfo
      }, __jsx("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20"
      }, __jsx("g", {
        id: "expand02",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, __jsx("g", {
        id: "ios-arrow-dropdown-circle-copy-2",
        fillRule: "nonzero"
      }, __jsx("path", {
        d: "M0,10 C0,15.5240385 4.47596154,20 10,20 C15.5240385,20 20,15.5240385 20,10 C20,4.47596154 15.5240385,0 10,0 C4.47596154,0 0,4.47596154 0,10 Z",
        id: "Shape",
        fill: "#DADADA"
      }), __jsx("path", {
        d: "M13.5567806,7.40030763 C13.885782,7.00849257 14.4253442,7.00849257 14.7543456,7.40030763 C14.9210397,7.59882726 15,7.8548131 15,8.11079893 C15,8.36678477 14.916653,8.62799481 14.7499589,8.82651444 L10.6133148,13.7372632 C10.2799267,14.097733 9.76668454,14.0872846 9.44645652,13.705918 L5.24839877,8.72203042 C4.91939738,8.33021537 4.9150107,7.69286287 5.24839877,7.29582361 C5.57740016,6.90400855 6.11257576,6.89878435 6.44596384,7.29582361 L10.0035655,11.574444 L13.5567806,7.40030763 L13.5567806,7.40030763 Z",
        id: "Path",
        fill: "#FFFFFF"
      }))))) : __jsx(ExpanderPad, null);
    }, _this.renderDateBlock = function (expiry, info, needsExpander) {
      return expiry || info || needsExpander ? __jsx(DateWrapper, null, expiry && __jsx(CouponExpiry, null, moment(expiry).endOf('days').diff(moment().format('YYYY-MM-DD'), 'days'), " DAYS LEFT"), __jsx(MediaQuery, {
        query: responsiveQuery.mobile
      }, _this.renderExpander(needsExpander)), info && __jsx(ImportantButton, {
        link: true,
        block: true,
        onPress: _this.toggleInfo
      }, "Terms & conditions")) : __jsx(MediaQuery, {
        query: responsiveQuery.tabletAndDesktop
      }, __jsx(DateWrapper, null));
    }, _assertThisInitialized(_this)));
  }
  _inherits(Coupon, _Component);
  return _createClass(Coupon, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        couponId = _this$props.couponId,
        title = _this$props.title,
        code = _this$props.code,
        description = _this$props.description,
        info = _this$props.info,
        expiry = _this$props.expiry,
        merchant = _this$props.merchant,
        fetchingClickUrl = _this$props.fetchingClickUrl,
        isIncentiveNetworksDown = _this$props.isIncentiveNetworksDown;
      var infoIsExpanded = this.state.infoIsExpanded;
      var needsExpander = info || description && description.length > 47;
      return __jsx(MerchantCoupon, this.props, __jsx(FlexWrapper, null, __jsx(DesktopExpander, null, this.renderExpander(needsExpander)), __jsx(TitleWrapper, null, __jsx(CouponTitle, null, title), __jsx(CouponBody, null, description)), __jsx(MediaQuery, {
        query: responsiveQuery.tabletAndDesktop
      }, this.renderDateBlock(expiry, info, needsExpander)), code ? __jsx(CouponWrapper, null, __jsx("div", null, __jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14"
      }, __jsx("g", {
        fill: "none",
        fillRule: "evenodd"
      }, __jsx("circle", {
        cx: "7",
        cy: "7",
        r: "7",
        fill: "#8DE2E0"
      }), __jsx("path", {
        fill: "#4A4A4A",
        d: "M4.456 9.24L3.062 7.847l.87-.87L5.327 8.37l4.352-4.352.782.783-5.222 5.221-.782-.782z"
      }))), "Copied"), __jsx(CouponCode, {
        hasCode: code,
        onClick: this.copyToClipboard
      }, code)) : __jsx(CouponCode, null, "No coupon code is required"), __jsx(DealCta, {
        onPress: function onPress() {
          return _this2.doShop(merchant.merchantId, couponId);
        },
        secondary: true,
        narrow: true,
        outline: true,
        disabled: isIncentiveNetworksDown,
        loading: fetchingClickUrl,
        hasName: "merchant_OM_".concat(couponId)
      }, "shop offer"), __jsx(MediaQuery, {
        query: responsiveQuery.mobile
      }, this.renderDateBlock(expiry, info, needsExpander))), __jsx(CardInfo, {
        isVisible: infoIsExpanded
      }, __jsx("button", {
        onClick: this.toggleInfo
      }, __jsx(Icon, {
        iconType: "closeCross",
        size: "xs"
      })), __jsx(InfoWrapper, null, __jsx("p", null, description), info && __jsx(React.Fragment, null, __jsx("p", null, __jsx("b", null, "Terms and conditions")), __jsx("p", null, info)))));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user,
    shop = _ref.shop,
    flags = _ref.flags;
  return {
    user: user,
    shop: shop,
    flags: flags
  };
};
var mapDispatchToProps = {
  shopNow: clickToShop,
  openLoginModal: openLoginModal,
  clearClick: clearClickUrl
};
Coupon.defaultProps = {
  couponId: '',
  info: '',
  expiry: '',
  code: '',
  description: '',
  shopNow: function shopNow() {
    // intentionally empty thanks sonar
  },
  fetchingClickUrl: false,
  user: {},
  openLoginModal: function openLoginModal() {
    // intentionally empty thanks sonar
  }
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(CouponWithOptimizely);